export enum MenuItemCategories {
  "page"= "Pages",
  "post"= "Posts",
  "e-landing-page"= "Landing pages",
  "product"= "Products",
  "custom"= "Custom links",
  "category"= "Categories",
  "post_tag"= "Tags",
  "product_cat"= "Product categories",
  "product_tag"= "Product tags"
}
